<template>
  <div class="client-item-box" :class="{'plr15': !data.fullWidth, 'mb15': !data.hideBottomGap }" :data-trackdata="tData">
    <div class="image-banner-box">
      <!-- <div class="slide-wrap j_slide_wrap"> -->
        <div class="images" v-if="swiper">
          <swiper 
            :config="swiper"
            :paginateCls="paginateCls" 
            :showPaginate="showPaginate">
            <div class="swiper-slide" v-for="(item, index) in items" v-if="item.image.src" @click="imageAction(item, index)">
              <img :src="ensureImage(item.image.src)" />
            </div>
          </swiper>
        </div>
    </div>
  </div>
</template>

<script>

import { ensure_protocol } from '@beastshop/url-util'
import { getClientWidth, trackAction } from '../lib/util.js'
import { transformLink, normalSkip, getToMiniLink, getLinkPageData } from '@/link'

// import Swiper from '@/swiper/swiper-3.4/index.vue'
// import Swiper from '@/swiper/swiper-4.2/index.vue'
import Swiper from '@/swiper/swiper-4.4.6/index.vue'
import beastImage from '@/components/image'

const clientWidth = getClientWidth()
const paginateCls = { 'number-paginate': true }

export default {
  name: 'image-banner',
  // props: ['data'],
  props: ['data', 'memberTags', 'paginateType', 'isApp'],
  data () {
    return {
      items: [],
      swiper: null,
      paginateCls: (!this.data.hideIdentification && this.paginateType==='number')?paginateCls:{},
      // paginateCls: {},
      showPaginate: this.data.hideIdentification?false:true,
      tData: JSON.stringify(this.data.trackData || {})
    }
  },
  components: {
    Swiper,
    beastImage
  },
  mounted () {
  },
  computed: {
    renderSlideSize () {
    }
  },
  created() {
    this.formatData()
  },
  methods: {
    formatData () {
      // if(this.member === 'OLD') {
      //   this.data.items && this.data.items.forEach(item => {
      //     if(item.customer !== 'NEW') {
      //       items.push(item)
      //     }
      //   })
      // } else if (this.member === 'NEW') {
      //   this.data.items && this.data.items.forEach(item => {
      //     if(item.customer !== 'OLD') {
      //       items.push(item)
      //     }
      //   })
      // } else {
      //   items = this.data.items
      // }
      let items = []
      const tags = this.memberTags || []
      if(!tags.length) {//不校验新老客
        items = this.data.items
      } else {
        this.data.items && this.data.items.forEach(item => {
          if(item.customer === 'ALL' || tags.indexOf(item.customer) !== -1 || (item.customer === 'DELINEATION' && tags.indexOf(item.customerCode) !== -1)) {
            items.push(item)
          }
        })
      }

      this.swiper = {
        pagination: this.data.hideIdentification
                      ? '' 
                      : (this.paginateType==='number')
                        ? {
                            el: '.swiper-pagination', 
                            type: 'fraction',
                          }
                        : {
                            el: '.swiper-pagination',
                            type: 'bullets'
                          },
        paginationClickable: true,
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: 4000,
        autoplayDisableOnInteraction: false,
        // onPaginationRendered: this.paginationRendered
      }
      // console.log(this.swiper, "swiper")

      this.items = items
    },
    ensureImage (src) {
      return ensure_protocol(src)
    },
    imageAction (item, index) {
      let myLink = ''
      let toMiniFlag = false
      if(this.isApp && item.toMiniProgram) {//app环境 且 在app打开小程序页面
        myLink = getToMiniLink({
                link: item.link,
                title: item.title
              })
      }
      if(myLink) {
        toMiniFlag = true
      }
      if(!myLink) {
        myLink = transformLink({
                link: item.link,
                title: item.title
              })
      }

      const trackData = this.data.trackData
      trackData.module_number = index-0+1
      trackData.operation_name = item.trackTitle
      trackData.operation_type = item.trackServiceType || ''
      trackAction({
        trackData,
        pageObj: getLinkPageData({
          link: item.link,
          title: item.title
        })
      })

      normalSkip({
        link: myLink,
        toMiniProgram: toMiniFlag
      },)
    },
  }
}
</script>



// WEBPACK FOOTER //
// image-banner.vue?0a175784